import { Guid } from "../../Guid";

class EmployeeLight {
    constructor(contactFacetId: Guid, FullName: string, licenceNumber: string) {
        this.ContactFacetId = contactFacetId;
        this.FullName = FullName;
        this.LicenceNumber = licenceNumber;
    }

    public ContactFacetId: Guid;
    public FullName: string;
    public LicenceNumber: string;
}

export { EmployeeLight };
